// None needed
Storage.prototype.setup = function (container) {
	this.container = container;
	this.container.storage = this;

	this.load();

	this.listenTo(container.tracking, "onBeforeSave", this.save);
	this.listenTo(container.tracking, "onClear", this.reset);
	this.listenTo(container.session, "onChangeSlide", this.handleChangeSlide);
	this.listenTo(container.session, "onJunctionUpdate", function (e) {
		this.handleChangeSlide(e);
		this.save();
	});
};

AudioManager.prototype.add = function(id, url)
{
	var currentPageId = this.container.router.getCurrentPageId();

	this.loader.addSound(id, url);
	this.assetsLoaded.push({
		pageId: currentPageId,
		audioId: id
	});

	return true;
};

Block.prototype.initializeAudio = function() {
	return;
};

TextColumns.prototype.handleResize = function() {

	if( !this.$rowDiv ) return;

	var windowHeight = this.app.height;
	Logger.info("height", windowHeight);
	var imageColumnHeight = this.$rowDiv.height();
	var finalHeight;
	if (windowHeight > imageColumnHeight) {
		finalHeight = windowHeight - this.navigationHeight;
	} else {
		finalHeight = imageColumnHeight;
	}
	TweenLite.set(this.$imageDiv, {
		height: finalHeight
	});
}